// extracted by mini-css-extract-plugin
export var backdrop = "CreateResume-module--backdrop---nlVO";
export var meta = "CreateResume-module--meta--GyL+0";
export var page = "CreateResume-module--page--fe1lb";
export var resume = "CreateResume-module--resume--5Y57Q";